import React from 'react';
import SharedUnavailableCard from '../UnavailableCard';
import unavailable_animation from '../../../assets/animations/unavailable/grid.gif';

const UnavailableCard = () => (
  <SharedUnavailableCard
    title="Grid data unavailable"
    message="Grid data is not ready yet. Please contact your system administrator for more details."
    image={unavailable_animation}
  />
);

export default UnavailableCard;
